import React, { useState } from 'react';
import { Button, TextField, IconButton, InputAdornment, CircularProgress } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import styles from './PasswordForm.module.scss';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function PasswordForm({
  onSubmit,
  isLoading,
  errorMessage,
  passwordLabel,
  submitButtonText 
}) {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmitClick = () => {
    onSubmit(password);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && password.trim() && !isLoading) {
      handleSubmitClick();
    }
  };

  return (
    <div className={styles.passwordContainer}>
      <TextField
        type={showPassword ? 'text' : 'password'}
        label={passwordLabel || t('login.password')}
        variant="outlined"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={handleKeyDown}
        error={Boolean(errorMessage)}
        helperText={errorMessage}
        fullWidth
        sx={{
          '& .MuiInputBase-root': {
            height: { xs: '48px', sm: '56px' }
          },
          '& .MuiInputLabel-root': {
            fontSize: { xs: '14px', sm: '16px' }
          }
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton 
                onClick={handleTogglePassword} 
                edge="end"
                sx={{
                  padding: { xs: '8px', sm: '12px' }
                }}
              >
                {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Link to="/forgot-password" className={styles.forgotPassword}>
        {t('login.forgotPassword')}
      </Link>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmitClick}
        disabled={isLoading || !password.trim()}
        fullWidth
        sx={{
          padding: { xs: '10px 16px', sm: '12px 24px' },
          fontSize: { xs: '14px', sm: '16px' },
          height: { xs: '48px', sm: '56px' }
        }}
      >
        {isLoading ? (
          <CircularProgress size={24} sx={{ color: 'white' }} />
        ) : (
          submitButtonText || t('login.loginButton')
        )}
      </Button>
    </div>
  );
}
